import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser
} from "@fortawesome/free-solid-svg-icons";
import "../../styles/workshop_infos.css";

import EPCISelection from "./EPCISelection";

const Header = (props) => {
    const {workshopData, setPage, page, setModalOptionsWS, EPCI, setEPCI} = props;
    return (
            <div className="main_container">
            {/* 1 : NAME */}
            <h1 className="container_title">Atelier "{workshopData.workshop_name}"</h1>

            <div className="workshop-summary">
                {/* 2 : NAV */}
                {workshopData.results.length > 0 && (
                    <div className="workshop-nav flex-item acenter jcenter">
                    <button
                        className={page === "Synthèse" ? "btn tab-btn active" : "btn tab-btn"}
                        type="button"
                        onClick={() => setPage("Synthèse")}
                    >
                        Synthèse
                    </button>
                    <button
                        className={page === "Secteurs" ? "btn tab-btn active" : "btn tab-btn"}
                        type="button"
                        onClick={() => setPage("Secteurs")}
                    >
                        Secteurs et Paramètres
                    </button>
                    <button
                        className={page === "Participants" ? "btn tab-btn active" : "btn tab-btn"}
                        type="button"
                        onClick={() => setPage("Participants")}
                    >
                        Participants
                    </button>
                    </div>
                )}

                <EPCISelection EPCI={EPCI} setEPCI={setEPCI} />

                {/* 3 : SPECS + MENU */}
                <div className="workshop-header-right flex-item acenter">
                    <div className="workshop-specs flex-item acenter">
                    <FontAwesomeIcon icon={faUser} />
                    <p>{workshopData.results.length}</p>
                    </div>

                    <button className="btn primary-btn" type="button" onClick={() => setModalOptionsWS(true)}>
                    Options
                    </button>
                </div>
            </div>

            </div>
        )
}

export default Header